import React, { useState } from 'react';
import { BsClockHistory } from 'react-icons/bs';
import { useCustomer } from './CustomerContext';
import EmptyState from './components/EmptyState';
import StatusBadge from './components/StatusBadge';
import { formatDate } from '../../utils/api';

const fmtHoras = (minutos) => {
  const m = Math.round(Number(minutos) || 0);
  const neg = m < 0;
  const a = Math.abs(m);
  const h = Math.floor(a / 60);
  const min = a % 60;
  return `${neg ? '-' : ''}${h}h${min ? ` ${min}min` : ''}`;
};

const Stat = ({ label, value, color }) => (
  <div style={{ minWidth: 92 }}>
    <div style={{ fontSize: '0.72rem', color: '#9aa3b2', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
    <div style={{ fontWeight: 700, fontSize: '1.05rem', color: color || '#1f2733' }}>{value}</div>
  </div>
);

const CustomerTimePacksPage = () => {
  const { timePacks, loading } = useCustomer();
  const [openId, setOpenId] = useState(null);

  if (loading) {
    return (
      <div>
        <div className="cp-skeleton cp-skeleton-title" />
        <div className="cp-skeleton cp-skeleton-card" style={{ height: 220 }} />
      </div>
    );
  }

  return (
    <div>
      <h1 className="cp-page-title">Bolsas de horas</h1>

      {!timePacks.length ? (
        <EmptyState icon={BsClockHistory} title="Sin bolsas de horas" subtitle="Aún no tienes bonos de mantenimiento o soporte." />
      ) : (
        timePacks.map((p) => {
          const totalMin = Math.round(Number(p.total_hours) * 60);
          const consumido = Number(p.minutos_consumidos) || 0;
          const restante = totalMin - consumido;
          const pct = totalMin > 0 ? Math.min(100, Math.round((consumido / totalMin) * 100)) : 0;
          const over = restante < 0;
          const entradas = Array.isArray(p.entradas) ? p.entradas : [];
          const isOpen = openId === p.id;
          return (
            <div key={p.id} className="cp-card-static" style={{ padding: 18, marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <div>
                  {p.referencia && (
                    <div style={{ fontSize: '0.8rem', fontWeight: 700, color: '#2E9BE0', letterSpacing: '0.06em', fontFamily: 'monospace' }}>{p.referencia}</div>
                  )}
                  <div style={{ fontWeight: 600, fontSize: '1.05rem' }}>{p.label}</div>
                  {p.fecha_inicio && (
                    <div style={{ fontSize: '0.78rem', color: '#9aa3b2', marginTop: 2 }}>Inicio: {formatDate(p.fecha_inicio)}</div>
                  )}
                </div>
                <StatusBadge status={p.status} />
              </div>

              <div style={{ display: 'flex', gap: 28, margin: '14px 0 10px', flexWrap: 'wrap' }}>
                <Stat label="Contratadas" value={fmtHoras(totalMin)} />
                <Stat label="Consumidas" value={fmtHoras(consumido)} color="#b8860b" />
                <Stat label="Restantes" value={fmtHoras(restante)} color={over ? '#dc3545' : '#198754'} />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div
                  role="progressbar"
                  aria-valuenow={pct}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label={`Consumo de ${p.referencia || p.label}`}
                  style={{ flex: 1, height: 8, borderRadius: 999, background: '#eceff3', overflow: 'hidden' }}
                >
                  <div style={{ width: `${pct}%`, height: '100%', borderRadius: 999, background: over ? '#dc3545' : 'linear-gradient(90deg,#50BAFC,#2E9BE0)', transition: 'width .3s ease' }} />
                </div>
                <span style={{ fontSize: '0.78rem', fontWeight: 700, color: over ? '#dc3545' : '#2E9BE0', whiteSpace: 'nowrap' }}>{pct}% consumido</span>
              </div>

              {entradas.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenId(isOpen ? null : p.id)}
                    style={{ background: 'none', border: 'none', color: '#2E9BE0', cursor: 'pointer', padding: 0, fontSize: '0.85rem', fontWeight: 500 }}
                  >
                    {isOpen ? 'Ocultar histórico' : `Ver histórico (${entradas.length})`}
                  </button>
                  {isOpen && (
                    <div style={{ overflowX: 'auto', marginTop: 8 }}>
                      <table className="cp-table">
                        <thead>
                          <tr><th>Fecha</th><th>Horas</th><th>Descripción</th></tr>
                        </thead>
                        <tbody>
                          {entradas.map((e, idx) => (
                            <tr key={idx}>
                              <td>{formatDate(e.fecha)}</td>
                              <td>{fmtHoras(e.minutos)}</td>
                              <td>{e.descripcion || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default CustomerTimePacksPage;
